import { useLocation, useNavigate } from "react-router-dom";

const BRAND = "#12B0A0";

const USER_BOTTOM_ITEMS = [
  {
    key: "home",
    label: "首页",
    icon: "ri-home-5-line",
    activeIcon: "ri-home-5-fill",
    path: "/home",
  },
  {
    key: "chat",
    label: "行程",
    icon: "ri-chat-smile-2-line",
    activeIcon: "ri-chat-smile-2-fill",
    path: "/ai-voice",
  },
  {
    key: "profile",
    label: "个人中心",
    icon: "ri-user-3-line",
    activeIcon: "ri-user-3-fill",
    path: "/profile",
  },
];

export default function UserBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{
        background: "#fff",
        borderTop: "1px solid #f0f0f0",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.04)",
      }}
    >
      <div className="flex items-end justify-around px-5 pt-2 pb-3">
        {USER_BOTTOM_ITEMS.map((item) => {
          const active = location.pathname === item.path;

          // ── 中间入口：白底圆形凸起 → /ai-voice（仅图标，不显示文字） ──
          if (item.key === "chat") {
            return (
              <button
                key={item.key}
                onClick={() => navigate(item.path)}
                aria-label={item.label}
                className="flex items-center justify-center cursor-pointer active:scale-95 transition-transform"
                style={{ minWidth: 64 }}
              >
                <div
                  className="flex items-center justify-center"
                  style={{
                    width: 62,
                    height: 62,
                    marginTop: -34,
                    marginBottom: 2,
                    background: "#fff",
                    border: "1px solid #EEF1F3",
                    borderRadius: 39,
                    overflow: "hidden",
                    boxShadow: active
                      ? "0 5px 16px rgba(18,176,160,0.3)"
                      : "0 3px 12px rgba(0,0,0,0.12)",
                  }}
                >
                  <img
                    src="/chat-panda.png"
                    alt={item.label}
                    className="object-contain"
                    style={{ width: 100, height: 70, borderRadius: 39 }}
                  />
                </div>
              </button>
            );
          }

          return (
            <button
              key={item.key}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center gap-1 cursor-pointer active:scale-95 transition-transform"
              style={{ minWidth: 64 }}
            >
              <i
                className={active ? item.activeIcon : item.icon}
                style={{ color: active ? BRAND : "#C0C4CC", fontSize: 20, lineHeight: 1 }}
              />
              <span
                className="text-[11px]"
                style={{ color: active ? BRAND : "#999", fontWeight: active ? 600 : 400 }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
